import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

import { ErrorDetails } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class ToastsService {
  private readonly duplicateToastDelay = 5000;
  private readonly recentMessages = new Map<string, number>();

  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  showSuccess(details: string, title: string = this.translate.instant('toasts.titleInfo'), life: number = 3000) {
    const message = { severity: 'success', summary: title, detail: details, life: life };
    this.addMessage(message);
  }

  showInfo(details: string, title: string = this.translate.instant('toasts.titleSuccess'), life: number = 3000) {
    const message = { severity: 'info', summary: title, detail: details, life: life };
    this.addMessage(message);
  }

  showWarn(details: string, title: string = this.translate.instant('toasts.titleWarn'), life: number = 3000) {
    const message = { severity: 'warn', summary: title, detail: details, life: life };
    this.addMessage(message);
  }

  showError(
    details: string | ErrorDetails,
    title: string = this.translate.instant('toasts.titleError'),
    life: number = 3000
  ) {
    const message = { severity: 'error', summary: title, detail: null, life: life };
    if (typeof details === 'string') {
      message.detail = details as string;
    }
    if (typeof details === 'object') {
      message.detail = details.details ?? details.message;
      message.summary = details.details && details.message ? details.message : title;
    }
    this.addMessage(message);
  }

  clear(key?: string) {
    this.messageService.clear(key);
  }

  private addMessage(message: ToastMessageOptions) {
    const key = `${message.severity}|${message.summary}|${message.detail}`;
    const now = Date.now();
    const lastShown = this.recentMessages.get(key);

    if (lastShown && now - lastShown < this.duplicateToastDelay) {
      return;
    }

    this.recentMessages.set(key, now);
    this.messageService.add(message);
  }
}
